import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getLogger } from "../../base/globals";
export function authenticate() {
    let logger = getLogger('firebase.authenticate');
    /*
    const firebaseConfig = {
        apiKey: "AIzaSyALwsMGLCEdLt6H1hxRgDk33mAWfneRtBk",
        authDomain: "eq-auth-test-alpha-1.firebaseapp.com",
        projectId: "eq-auth-test-alpha-1",
        storageBucket: "eq-auth-test-alpha-1.appspot.com",
        messagingSenderId: "9590749063",
        appId: "1:9590749063:web:d1399419d8c4ce30834522",
        measurementId: "G-8BBXXQZRW9"
    };
     */
    const firebaseConfig = {
        apiKey: "AIzaSyDNGACs7T7q8i4JO55UjkGBOyTXG7eeYik",
        authDomain: "lubec-df16b.firebaseapp.com",
        projectId: "lubec-df16b",
        storageBucket: "lubec-df16b.appspot.com",
        messagingSenderId: "588564569469",
        appId: "1:588564569469:web:3bea704feceea590368014",
        measurementId: "G-2VKF5PVD1N"
    };
    let deferred = $.Deferred();
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    const googleprovider = new GoogleAuthProvider();
    const facebookprovider = new FacebookAuthProvider();
    $('.firebaseui-auth-container').empty().append('<p class="firebaseui-auth-title">Sign In</p>' +
        '<div class="firebaseui-auth-opt auth-btn-google">' +
        '<img class="firebaseui-icon" alt="Google"' +
        ' src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg">' +
        'Sign in with Google' +
        '</div>' +
        '<div class="firebaseui-auth-opt auth-btn-facebook">' +
        '<img class="firebaseui-icon" alt="Facebook"' +
        ' src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg">' +
        'Sign in with Facebook' +
        '</div>'
    /*
    '<div class="firebaseui-auth-opt auth-btn-email">'+
        '<img class="firebaseui-icon" alt="Email"'+
        ' src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg">'+
        'Sign in with email'+
    '</div>'+
    '<div class="firebaseui-auth-opt auth-btn-twitter">'+
        '<img class="firebaseui-icon" alt="Twitter"'+
        ' src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/twitter.svg">'+
        'Sign in with Twitter'+
    '</div>'
        */
    );
    $('.auth-btn-google').on("click", () => {
        signInWithPopup(auth, googleprovider)
            .then((result) => {
            if (result) {
                // This gives you a Google Access Token. You can use it to access Google APIs.
                const googlecredential = GoogleAuthProvider.credentialFromResult(result);
                if (googlecredential) {
                    const googletoken = googlecredential.accessToken;
                }
                // The signed-in user info.
                const user = result.user;
                logger.debug('signInWithPopup (google) resolved');
                deferred.resolve(result);
            }
            else {
                logger.warning('signInWithPopup (google) resolved without result.');
                deferred.reject('signInWithPopup (google) resolved without result.');
            }
        })
            .catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            logger.error(`signInWithPopup (google) error: ${errorMessage}`, error);
            if (errorCode === 'auth/popup-closed-by-user')
                window.location.reload();
            // The AuthCredential type that was used.
            const googlecredential = GoogleAuthProvider.credentialFromError(error);
            deferred.reject(error);
        });
        return false;
    });
    $('.auth-btn-facebook').on("click", () => {
        signInWithPopup(auth, facebookprovider)
            .then((result) => {
            if (result) {
                // This gives you a Facebook Access Token. You can use it to access Faecbook APIs.
                const facebookcredential = FacebookAuthProvider.credentialFromResult(result);
                if (facebookcredential) {
                    const facebooktoken = facebookcredential.accessToken;
                }
                // The signed-in user info.
                const user = result.user;
                logger.debug('signInWithPopup (facebook) resolved');
                deferred.resolve(result);
            }
            else {
                logger.warning('signInWithPopup (facebook) resolved without result');
                deferred.reject('signInWithPopup (facebook) resolved without result');
            }
        })
            .catch((error) => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            logger.error(`signInWithPopup (facebook) error: ${errorMessage}`, error);
            if (errorCode === 'auth/popup-closed-by-user')
                window.location.reload();
            // The AuthCredential type that was used.
            const facebookcredential = FacebookAuthProvider.credentialFromError(error);
            deferred.reject(error);
        });
        return false;
    });
    /*
    $('.auth-btn-email').on('click', ()=>{
        alert("COMING SOON!");
        return false;
    });

    $('.auth-btn-twitter').on('click', ()=>{
        alert("COMING SOON!");
    });
    */
    return deferred.promise();
}
